class AccountLogin extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.checkUrlHash()
  }

  setupListeners () {
    super.setupListeners()

    this.handleRecoverTrigger = this.handleRecoverTrigger.bind(this)
    this.handleRecoverCancel = this.handleRecoverCancel.bind(this)

    this.listeners.add(
      this.els['recover-trigger'].element,
      'click',
      this.handleRecoverTrigger,
    )

    if (!this.els['recover-cancel']?.exists) return

    this.listeners.add(
      this.els['recover-cancel']?.element,
      'click',
      this.handleRecoverCancel,
    )
  }

  checkUrlHash () {
    const hash = window.location.hash

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      this.els['recover-panel'].element.setAttribute('aria-hidden', false)
    }
  }

  handleRecoverTrigger () {
    this.els['recover-panel'].element.setAttribute(
      'aria-hidden',
      this.els['recover-panel'].element.getAttribute('aria-hidden') !== 'true',
    )
  }

  handleRecoverCancel () {
    this.els['recover-panel'].element.setAttribute('aria-hidden', true)
  }
}

if (!customElements.get('account-login')) {
  customElements.define('account-login', AccountLogin)
}
